/* eslint-disable @typescript-eslint/prefer-optional-chain */
import { onPageUnload } from '../../../utils';
import { initMetric } from '../util';
var SPAMonitorMetricName = 'spa_load';
export var SPAMonitor = function () {
    return function (_props, cb) {
        var startTime = 0;
        var metric = initMetric(SPAMonitorMetricName, 0);
        var invokeCb = function (load_time) {
            metric.value = load_time;
            cb && cb(metric);
        };
        var performanceInit = function () {
            startTime = Date.now();
        };
        var performanceSend = function () {
            invokeCb(Date.now() - startTime);
            startTime = 0;
        };
        // 跳出率支持
        var handlePageUnload = function () {
            if (!startTime) {
                return;
            }
            metric.isBounced = true;
            performanceSend();
        };
        onPageUnload(handlePageUnload);
        return [performanceInit, performanceSend];
    };
};
//# sourceMappingURL=index.js.map